function titleFromFileName(fileName) {
    return fileName
        .replace(/\.[^.]+$/, "")
        .replace(/[-_]+/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .replace(/\b\w/g, (character) => character.toUpperCase());
}

function loadPhotographyImages() {
    const context = require.context("../img/photography", true, /\.(avif|jpe?g|png|webp)$/i);

    return context.keys()
        .map((key) => {
            const normalizedKey = key.replace("./", "");
            const parts = normalizedKey.split("/");

            if (parts.length < 2) {
                return null;
            }

            const category = parts[0];
            const fileName = parts[parts.length - 1];
            const source = context(key);

            return {
                category,
                src: typeof source === "string" ? source : source.default,
                title: titleFromFileName(fileName),
                slug: `${category}-${fileName.replace(/\.[^.]+$/, "")}`.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
                fileName
            };
        })
        .filter(Boolean)
        .sort((left, right) => {
            const categoryComparison = left.category.localeCompare(right.category);

            if (categoryComparison !== 0) {
                return categoryComparison;
            }

            return left.fileName.localeCompare(right.fileName);
        });
}

export const photographyImages = loadPhotographyImages();

export const photographyCategories = [
    "All",
    ...Array.from(new Set(photographyImages.map((image) => image.category)))
        .sort((left, right) => left.localeCompare(right))
];
